import { Card, CardBody, CardExpandToggler } from '../../../../components/card/card.jsx';
// import { useTranslation } from 'react-i18next';
import Breadcrumb from '../../../../components/Shared/Breadcrumb';
import Pie from '../../../dashboard/Pie.jsx';
import Bar from '../../../dashboard/Bar.jsx';

const FAHome = () => {
  // const { t } = useTranslation();

  //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
  const assetStatusData = {
    series: [45, 30, 15, 10], // النسب المئوية لكل حالة
    labels: ['مستخدمة', 'جديدة', 'معطلة', 'مباعة'], // الحالات
  };
  const assetCategoriesData = {
    series: [
      {
        name: 'قيمة الأصول (بالريال)',
        data: [50000, 75000, 30000, 15000], // القيم لكل تصنيف
      },
    ],
    categories: ['معدات', 'مركبات', 'أثاث', 'أجهزة إلكترونية'], // التصنيفات
  };
  const assetsByBranchData = {
    series: [
      { name: 'معدات', data: [30, 25, 15, 10] },
      { name: 'مركبات', data: [20, 15, 10, 5] },
      { name: 'أثاث', data: [10, 8, 6, 4] },
    ],
    categories: ['الفرع الرئيسي', 'فرع الرياض', 'فرع جدة', 'فرع المدينة المنورة'], // أسماء الفروع
  };

  const assetMovementLog = [
    {
      date: '2025-01-01',
      operation: 'إعادة تقييم',
      asset: 'سيارة لكزس',
      branch: 'فرع الرياض',
      value: '500,000 ريال سعودي',
    },
    {
      date: '2025-01-03',
      operation: 'إهلاك',
      asset: 'جهاز حاسوب مكتبي',
      branch: 'فرع جدة',
      value: '50,000 ريال سعودي',
    },
    {
      date: '2025-01-05',
      operation: 'نقل',
      asset: 'طاولة اجتماعات',
      branch: 'فرع الدمام',
      value: 'لا ينطبق',
    },
    {
      date: '2025-01-07',
      operation: 'بيع',
      asset: 'آلة تصوير مستندات',
      branch: 'فرع المدينة المنورة',
      value: '150,000 ريال سعودي',
    },
    {
      date: '2025-01-09',
      operation: 'إعادة تقييم',
      asset: 'مولد كهرباء ديزل',
      branch: 'فرع مكة المكرمة',
      value: '300,000 ريال سعودي',
    },
  ];

  const assetTypeCountData = {
    series: [
      {
        data: [50, 30, 20, 10],
      },
    ],
    categories: ['أجهزة', 'سيارات', 'أثاث', 'معدات'],
  };

  return (
    <>
      <Breadcrumb
        BreadcrumbList={[
          {
            name: 'Home',
            link: null,
          },
        ]}
      />
      <div className="row g-3">
        <div className="col-12 col-md-6 col-lg-7">
          <Card className="mb-3" style={{ height: '100%' }}>
            <CardBody>
              <div className="d-flex fw-bold small mb-3">
                <span className="flex-grow-1 fs-6 fw-bold"> سجل حركة الأصول</span>
                <CardExpandToggler />
              </div>
              <div className="table-responsive">
                <table className="table table-hover">
                  <thead className="bg-theme bg-opacity-30">
                    <tr>
                      <th>التاريخ</th>
                      <th>نوع العملية</th>
                      <th>اسم الأصل</th>
                      <th>الفرع</th>
                      <th>القيمة</th>
                    </tr>
                  </thead>
                  <tbody>
                    {assetMovementLog.map((movement, index) => (
                      <tr key={index}>
                        <td className="align-middle">{movement.date}</td>
                        <td className="align-middle">{movement.operation}</td>
                        <td className="align-middle">{movement.asset}</td>
                        <td className="align-middle">{movement.branch}</td>
                        <td className="align-middle">{movement.value}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </CardBody>
          </Card>
        </div>
        <div className="col-12 col-md-6 col-lg-5">
          <Card className="mb-3" style={{ height: '100%' }}>
            <CardBody>
              <div className="d-flex fw-bold small mb-3">
                <span className="flex-grow-1 fs-6 fw-bold"> توزيع الأصول على الفروع </span>
                <CardExpandToggler />
              </div>

              <Bar
                categories={assetsByBranchData.categories}
                series={assetsByBranchData.series}
                height={300}
                isStacked
              />
            </CardBody>
          </Card>
        </div>
        <div className="col-12 col-md-6 col-lg-4">
          <Card className="mb-3" style={{ height: '100%' }}>
            <CardBody>
              <div className="d-flex fw-bold small mb-3">
                <span className="flex-grow-1 fs-6 fw-bold">نسبة الأصول حسب الحالة</span>
                <CardExpandToggler />
              </div>

              <Pie labels={assetStatusData.labels} series={assetStatusData.series} height={300} />
            </CardBody>
          </Card>
        </div>

        <div className="col-12 col-md-6 col-lg-4">
          <Card className="mb-3" style={{ height: '100%' }}>
            <CardBody>
              <div className="d-flex fw-bold small mb-3">
                <span className="flex-grow-1 fs-6 fw-bold">قيمة الأصول حسب التصنيفات </span>
                <CardExpandToggler />
              </div>

              <Bar
                categories={assetCategoriesData.categories}
                series={assetCategoriesData.series}
                height={400}
              />
            </CardBody>
          </Card>
        </div>

        <div className="col-12 col-md-6 col-lg-4">
          <Card className="mb-3" style={{ height: '100%' }}>
            <CardBody>
              <div className="d-flex fw-bold small mb-3">
                <span className="flex-grow-1 fs-6 fw-bold">عدد الأصول حسب النوع </span>
                <CardExpandToggler />
              </div>

              <Bar
                categories={assetTypeCountData.categories}
                series={assetTypeCountData.series}
                height={400}
                isHorizontal
              />
            </CardBody>
          </Card>
        </div>
      </div>
    </>
  );
};

export default FAHome;
